import React from 'react';
import { connect } from 'react-redux';
import { IPublicRestaurant, MessageType, StringUtils } from '@localina/core';
import { Page } from '../../components';
import { IApplicationStore } from '../../interfaces';
import { DateTime, Done, Person, Summary, Welcome } from './Steps';
import * as actions from '../../store/reservation/reservation-actions';

interface IStoreProps {
    restaurant?: IPublicRestaurant;
    isLoading: boolean;
}

interface IActionProps {
    resetError: typeof actions.resetError;
}

type IProps = IStoreProps & IActionProps;

const Reservation: React.FC<IProps> = (props) => {
    const [step, setStep] = React.useState(1);

    React.useEffect(() => {
        if (props.restaurant?.messages.find((it) => it.type === MessageType.WELCOME)) {
            setStep(0);
        }
    }, [props.restaurant]);

    const scrollToTop = () => {
        const main = document.getElementsByTagName('main')[0];
        main.scrollTop = 0;
    };
    const handleNext = () => {
        setStep(step + 1);
        scrollToTop();
    };
    const handleBack = () => {
        setStep((p) => p - 1);
        props.resetError();
        scrollToTop();
    };

    const getPage = () => {
        if (!props.restaurant) {
            return <></>;
        }

        switch (step) {
            case 0:
                return <Welcome restaurant={props.restaurant} onNext={handleNext} />;
            case 1:
                return <DateTime restaurant={props.restaurant} onNext={handleNext} />;
            case 2:
                return <Person restaurant={props.restaurant} onNext={handleNext} onBack={handleBack} />;
            case 3:
                return <Summary restaurant={props.restaurant} onNext={handleNext} onBack={handleBack} />;
            case 4:
                return <Done restaurant={props.restaurant} />;
        }
    };

    const getClassName = () => {
        switch (step) {
            case 0:
                return 'welcome';
            case 1:
                return 'datetime';
            case 2:
                return 'person';
            case 3:
                return 'summary';
            case 4:
                return 'done';
        }
    };

    return (
        <Page
            name={StringUtils.combineStrings(['reservation', getClassName()])}
            step={step}
            isLoading={props.isLoading}
            restaurant={props.restaurant}
        >
            {getPage()}
        </Page>
    );
};

const mapStateToProps = (state: IApplicationStore): IStoreProps => ({
    restaurant: state.restaurant.configuration,
    isLoading: state.reservation.isLoading || state.restaurant.isLoading,
});

const actionProps: IActionProps = {
    resetError: actions.resetError,
};

export default connect(mapStateToProps, actionProps)(Reservation);
